import { Stack, Typography } from '@common-components';
import { messages } from 'i18n';

type ColumnConfigType = {
  title: string;
  flex: number | string;
  align?: 'left' | 'center' | 'right' | 'inherit' | 'justify';
  paddingX?: number;
};

export enum CarriersColumns {
  Carrier = 'Carrier',
  Domains = 'Domains',
  Modules = 'Modules',
  StpThreshold = 'StpThreshold',
  LastUpdate = 'LastUpdate',
  MoreActions = 'MoreActions',
}

type CarriersColumnsConfig = Record<CarriersColumns, ColumnConfigType>;

export const columnConfig: CarriersColumnsConfig = {
  [CarriersColumns.Carrier]: {
    title: messages.carriersPage.columnHeaders.carrier,
    flex: '0 0 216px',
    align: 'left',
  },
  [CarriersColumns.Domains]: {
    title: messages.carriersPage.columnHeaders.domains,
    flex: 1,
    align: 'left',
    paddingX: 1,
  },
  [CarriersColumns.Modules]: {
    title: messages.carriersPage.columnHeaders.modules,
    flex: '0 0 150px',
    align: 'left',
  },
  [CarriersColumns.StpThreshold]: {
    title: messages.carriersPage.columnHeaders.stpThreshold,
    flex: '0 0 120px',
    align: 'left',
  },
  [CarriersColumns.LastUpdate]: {
    title: messages.carriersPage.columnHeaders.lastUpdated,
    flex: '0 0 97px',
    align: 'left',
  },
  [CarriersColumns.MoreActions]: {
    title: '',
    flex: '0 0 40px',
    align: 'left',
  },
};

export default function CarriersTableHeader() {
  return (
    <Stack
      bgcolor="common.white"
      position="sticky"
      top={0}
      zIndex={(theme) => theme.zIndex.appBar}
      direction="row"
      alignItems="center"
      flex={0}
      p={1.5}
      height={52}
      gap={3}
      borderBottom={1}
      borderColor="divider"
    >
      {Object.keys(columnConfig).map((key) => {
        const column = columnConfig[key as CarriersColumns];
        return (
          <Typography
            variant="body2"
            component="div"
            color="typography.nonEssential"
            align={column.align}
            flex={column.flex}
            paddingX={column.paddingX}
            key={key}
          >
            {column.title}
          </Typography>
        );
      })}
    </Stack>
  );
}
